/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
// Support component names relative to this directory:

import Mediator from 'mediator-js'
import axios from 'axios'
import * as ActiveStorage from 'activestorage'

import BarsOrdering from '../Utils/BarsOrdering'
import AjaxMonitor from '../Utils/AjaxMonitor'
import { AuthenticationInterceptor } from 'Pods/Shared/CookieInterceptor/CookieInterceptor'
import initChallengeEntriesPagination from 'Pods/Challenges/entriesPagination'
import {
  FilterTracker,
  CustomEventTracker,
  FooterNavigationTracker,
  HeaderNavigationTracker,
  CtaTracker,
} from 'Pods/Shared/UserTracker/UserTracker'
import loadLocaleBundle from 'Translations/loadLocaleBundle'

// Start fetching the active locale's translations at script-eval time so the
// bundle is registered before components hydrate (no English flash on non-EN
// pages like localized /3d-modeling-jobs). Resolves immediately on English pages.
const localeReady = loadLocaleBundle()

ActiveStorage.start()

window.BarsOrdering = BarsOrdering

// Initialize window.App BEFORE useContext so components can use App.events on DOMContentLoaded
if (typeof window.App === 'undefined') {
  window.App = {
    events: new Mediator(),
    config: {},
  }
}

// Set up CSRF token for axios BEFORE components mount (they may make requests in constructors)
const metaToken = document.getElementsByName('csrf-token')[0]
let token = null
if (metaToken) {
  token = metaToken.getAttribute('content')
  axios.defaults.headers.common['X-CSRF-Token'] = token
}
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
App.authenticityToken = token

// Make axios available globally BEFORE components mount
// Some components use window.axios instead of importing axios directly
window.axios = AjaxMonitor(axios)

// Set up ReactRailsUJS context IMMEDIATELY (before DOMContentLoaded)
// react_ujs auto-mounts on DOMContentLoaded, so useContext must be called before that fires.
// This ensures all components in the Pods directory can be resolved.
const ReactRailsUJS = require('react_ujs')
const ReactDOM = require('react-dom')
const { unmountReactRoot } = require('../vendor/reactRenderHelpers')

// Patch unmountComponents to use React 18's root.unmount() for roots created
// via createRoot/hydrateRoot. ReactRailsUJS is a singleton, so this patch
// propagates to all packs that require('react_ujs').
const originalFindDOMNodes = ReactRailsUJS.findDOMNodes
ReactRailsUJS.unmountComponents = function unmountComponents(searchSelector) {
  const nodes = originalFindDOMNodes.call(this, searchSelector)
  for (let i = 0; i < nodes.length; i += 1) {
    if (!unmountReactRoot(nodes[i])) {
      ReactDOM.unmountComponentAtNode(nodes[i])
    }
  }
}

// Defer every mount — including react_ujs's automatic DOMContentLoaded pass —
// until the locale bundle is registered (see USAGE CONTRACT in
// Translations/loadLocaleBundle). No-op delay on English pages.
// Relies on react_ujs (2.6.2) handleMount looking up
// ReactRailsUJS.mountComponents dynamically at event time — re-verify this
// patch on any react_ujs upgrade.
const originalMountComponents = ReactRailsUJS.mountComponents
ReactRailsUJS.mountComponents = function mountComponents(...args) {
  localeReady.then(() => originalMountComponents.apply(this, args))
}

ReactRailsUJS.useContext(
  require.context(
    'Pods',
    true,
    /^(?!.*(?:AffiliateProgram|ThreeDStudio|Enterprise|Homepage|Blog|New3dPrintModels|Coupons|NewHomepage|NewDownloadItemPage|ItemPage|ListingPage|BfPremiumDeal|NotFound|NewModelUploader|.*test.*$|.*story.*$)).*$/
  )
)

window.addEventListener('load', () => {
  AuthenticationInterceptor()
  FilterTracker()
  CustomEventTracker()
  FooterNavigationTracker('app-footer')
  HeaderNavigationTracker('app-header')
  CtaTracker()

  // Components are already mounted by react_ujs on DOMContentLoaded,
  // but we call mountComponents again for any dynamically added elements
  ReactRailsUJS.mountComponents()
  initChallengeEntriesPagination()
})
